import { initGlobalEventsLogs } from '@cian/events-log';

import { setupDependencies, initDependencies } from './dependencies';
import { start } from './start';

setupDependencies();
initDependencies();
initGlobalEventsLogs();

start();

// oxlint-disable-next-line typescript/no-explicit-any
if ((module as any).hot) {
  // oxlint-disable-next-line typescript/no-explicit-any
  (module as any).hot.accept();
}
